exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".PlayerRecords__headerContainer--2oqkN {\n  margin-top: 10px;\n}\n\n.PlayerRecords__playerHeader---kYnF {\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 1.46;\n  letter-spacing: 1px;\n  color: #f9f9f9;\n  opacity: 0.65;\n  display: inline-block;\n  text-transform: uppercase;\n}\n\n.PlayerRecords__statHeader--koIMT {\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 1.46;\n  color: #f9f9f9;\n  opacity: 0.65;\n  width: 80px;\n  float: right;\n  display: inline-block;\n  text-transform: uppercase;\n  text-align: center;\n}", ""]);

// exports
exports.locals = {
	"headerContainer": "PlayerRecords__headerContainer--2oqkN",
	"playerHeader": "PlayerRecords__playerHeader---kYnF",
	"statHeader": "PlayerRecords__statHeader--koIMT"
}; 
var style = module.exports.toString();module.exports = exports.locals || { stylesheet: "" };if (!module.exports.stylesheet) { module.exports.stylesheet = style; };